import { IAPIRequest, IAPIResponse } from "./AjaxService";

var API_CACHE: any = {};

const RequestValidForCache = (apiRequest: IAPIRequest) => {
  return apiRequest.method.toLocaleLowerCase() === "get";
};

const GetRequestSignature = (apiRequest: IAPIRequest) => {
  return apiRequest.method + "__" + apiRequest.url;
};

const GetCachedResponse = (apiRequest: IAPIRequest) => {
  if (apiRequest.method.toLocaleLowerCase() !== "get") {
    API_CACHE = {};
  }

  if (apiRequest.allowApiCache) {
    return API_CACHE[GetRequestSignature(apiRequest)];
  }
  return undefined;
};

const WriteResponseToCache = (
  apiRequest: IAPIRequest,
  apiResponse: IAPIResponse
) => {
  if (
    RequestValidForCache(apiRequest) &&
    apiResponse.error === null &&
    apiRequest.allowApiCache
  ) {
    API_CACHE[GetRequestSignature(apiRequest)] = apiResponse;
  }
};

const AjaxCache = {
  GetCachedResponse,
  WriteResponseToCache,
};

export default AjaxCache;
